export const TILSYN_VIRK_FORMAAL = [
  "Bygge- og anlægsvirksomhed",
  "Ejendomsmæglervirksomhed",
  "Ejendomsadministration",
  "Engros-/detailhandel",
  "Fremstillingsvirksomhed",
  "Hotel-/restaurationsvirksomhed",
  "Investeringsvirksomhed",
  "IT-virksomhed",
  "Komplementar i advokatpartnerselskab",
  "Konsulent-/rådgivningsvirksomhed - juridisk",
  "Konsulent-/rådgivningsvirksomhed - anden",
  "Kultur, forlystelser og sport",
  "Køb og salg/udlejning af fast ejendom",
  "Landbrug, jagt, skovbrug, fiskeri og råstofindvinding",
  "Revisionsvirksomhed",
  "Undervisnings-/kursusvirksomhed",
  "Andet",
] as const;

export const TILSYN_EJERANDELE = [
  "< 10%",
  "10 - 25%",
  "26 - 50%",
  "51 - 100%",
] as const;
